import styles from './RangeSlider.module.css';
import { topRangeHandle } from './rangeSlider.js';

// Dual-handle range slider (two overlaid native inputs sharing one track).
// onChange fires live while dragging; onCommit (optional) fires on release —
// used by the progress-page temperature filter to defer its server re-fetch
// until you let go. Shared by the Progress page and the session-list filters.
export default function RangeSlider({ min, max, step = 1, value, onChange, onCommit, format, width }) {
  const [lo, hi] = value;
  const pct = v => (max > min ? ((v - min) / (max - min)) * 100 : 0);
  const commit = () => onCommit && onCommit([lo, hi]);
  // Only the thumbs are hit-testable, so when the two land on the same pixels
  // stacking order decides which one you can grab — see topRangeHandle.
  const loOnTop = topRangeHandle({ lo, hi, max }) === 'lo';
  return (
    <div className={styles.rs} style={width ? { width } : undefined}>
      <div className={styles.rsTrack}>
        <div className={styles.rsFill} style={{ left: `${pct(lo)}%`, right: `${100 - pct(hi)}%` }} />
      </div>
      <input type="range" min={min} max={max} step={step} value={lo}
             aria-label="Range minimum"
             onChange={e => onChange([Math.min(Number(e.target.value), hi), hi])}
             onMouseUp={commit} onTouchEnd={commit}
             className={`${styles.rsInput}${loOnTop ? ` ${styles.rsInputTop}` : ''}`} />
      <input type="range" min={min} max={max} step={step} value={hi}
             aria-label="Range maximum"
             onChange={e => onChange([lo, Math.max(Number(e.target.value), lo)])}
             onMouseUp={commit} onTouchEnd={commit} className={styles.rsInput} />
      <div className={styles.rsLabels}>
        <span>{format(lo)}</span><span>{format(hi)}</span>
      </div>
    </div>
  );
}
